import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import InvokeLambda from '../lib/lambdaInvokeRegistrationData'
import RegistrationForm from '../components/Auth/Registration/RegistrationForm'
import Card from 'antd/lib/card'
import Input from 'antd/lib/input'
import Spin from 'antd/lib/spin'
import Icon from 'antd/lib/icon'
import ConfirmRegistration from '../components/Auth/Registration/ConfirmRegistration'
import loginBackground from '../assets/images/loginBackground.jpg'
import BSSLogo from '../components/Certificate/BSSLogo'
import { setTenant, setLoading, setErrorMessage, setShowLogin } from '../redux/auth/actions'
import AdditionalRegistrationForm from '../components/Auth/Registration/AdditionalRegistrationForm'
import history from '../History'

const styles = {
    backgroundContainer: {
        backgroundImage: `url(${loginBackground})`,
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        bottom: 0,
        height: '100%',
        left: 0,
        position: 'absolute',
        right: 0,
        top: 0,
    },
    card: {
        background: 'rgba(255, 255, 255, 0.74)',
        borderRadius: '7px',
        padding: '0 6% 0 6%',
    },
    formContainer: {
        position: 'absolute',
        left: '50%',
        margin: 'auto',
        top: '50%',
        transform: 'translate(-50%, -50%)',
        width: 520,
    },
    logoContainer: {
        margin: '0 auto',
        textAlign: 'center',
        width: '68%',
    },
    signInLink: {
        display: 'block',
        marginTop: '3em',
        textAlign: 'center',
    },
    link: {
        color: '#1BAAF1',
        cursor: 'pointer',
    },
    tokenField: {
        marginTop: '2em',
    },
    loadingContainer: {
        marginTop: '1em',
        display: 'flex',
        justifyContent: 'center',
    },
    loading: {
        color: '#1BAAF1',
    },
    infoContainer: {
        margin: '1em 0 1em 0',
        display: 'flex',
        justifyContent: 'space-around',
    },
    infoType: {
        color: '#000',
    },
    error: {
        color: 'red',
        textAlign: 'center',
        fontSize: 14,
    },
}

const Registration = ({ onStateChange, authState, authData }) => {
    const [token, setToken] = useState('')

    const width = useSelector((state) => state.app.width)
    const isLoading = useSelector((state) => state.auth.isLoading)
    const showForm = useSelector((state) => state.auth.showForm)
    const showConfirmationForm = useSelector((state) => state.auth.showConfirmationForm)
    const showTokenFields = useSelector((state) => state.auth.showTokenFields)
    const showAdditionalForm = useSelector((state) => state.auth.showAdditionalForm)
    const tenant = useSelector((state) => state.auth.tenant)
    const username = useSelector((state) => state.auth.username)
    const userAttributes = useSelector((state) => state.auth.userAttributes)
    const errorMessage = useSelector((state) => state.auth.errorMessage)

    useEffect(() => {
        setErrorMessage('')
    }, [])

    useEffect(() => {
        if (authData?.token) {
            setToken(authData.token)
            validateToken(authData.token)
        }
    }, [authData])

    const onChange = (e) => {
        setToken(e.target.value)
        validateToken(e.target.value)
    }

    const validateToken = (token) => {
        let Exp = /^[a-zA-Z0-9]{8}$/i
        if (token.length === 8 && !!token.match(Exp)) {
            setLoading()
            loadTenantInformation(token)
        }
    }

    const loadTenantInformation = (token) => {
        InvokeLambda(token).then((response) => {
            if (response.tenant) {
                setTenant(response)
                setErrorMessage('')
            } else {
                setLoading()
                setErrorMessage('Invalid Token')
            }
        })
    }

    const backToSignIn = () => {
        setShowLogin(true)
        onStateChange('signIn', {})
        history.push('/')
    }

    let containerStyle =
        width < 576 ? { ...styles.formContainer, width: '86%' } : styles.formContainer
    return (
        authState === 'signUp' && (
            <div style={styles.backgroundContainer}>
                <div style={containerStyle}>
                    <Card style={styles.card}>
                        <div style={styles.logoContainer}>
                            <svg
                                version="1.1"
                                viewBox="0 0 126.17 53.72"
                                width="100%"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <BSSLogo />
                            </svg>
                        </div>
                        {showTokenFields && (
                            <div style={styles.tokenField}>
                                Registration Token:
                                <Input value={token} onChange={onChange} />
                                <span>
                                    <Icon
                                        type="info-circle"
                                        style={{ marginRight: 5, color: '#08c' }}
                                        theme="filled"
                                    />
                                    Please contact your tenant administrator for the registration
                                    token
                                </span>
                            </div>
                        )}
                        {isLoading && (
                            <div style={styles.loadingContainer}>
                                <Spin
                                    style={styles.loading}
                                    tip="Loading..."
                                    loading={isLoading.toString()}
                                />{' '}
                            </div>
                        )}
                        {tenant && (
                            <div style={styles.infoContainer}>
                                <span>
                                    <span style={styles.infoType}>Building:</span> {tenant.building.name}
                                </span>
                                <span>
                                    <span style={styles.infoType}>Tenant:</span> {tenant.tenant.name}
                                </span>
                            </div>
                        )}
                        <div style={styles.error}>{errorMessage}</div>
                        {showForm && (
                            <RegistrationForm tenant={tenant} attributes={userAttributes} />
                        )}
                        {showAdditionalForm && (
                            <AdditionalRegistrationForm
                                suites={tenant.suites}
                                floors={tenant.floors}
                                attributes={userAttributes}
                                settings={tenant.settings}
                            />
                        )}
                        {showConfirmationForm && (
                            <ConfirmRegistration
                                username={username}
                                onStateChange={onStateChange}
                            />
                        )}
                        <span style={styles.signInLink}>
                            Already have an account?{' '}
                            <span onClick={backToSignIn} style={styles.link}>
                                Sign In
                            </span>
                        </span>
                    </Card>
                </div>
            </div>
        )
    )
}

export default Registration
